import styled from 'styled-components'

export const Main = styled.div`
  padding: 28px;
  border-radius: 12px;
`